import './ProgressBar.css'
interface Props
{
	percentage: number
	onNextClick: (() => void)
	onPreviousClick: (() => void)
	canGoPrevious: boolean
	canGoNext: boolean
}

const ProgressBar = (props: Props) =>
{
	return (
		<div className="d-flex flex-column justify-content-evenly align-items-center">
			<div className="d-flex flex-row justify-content-between progress-bar-name">
				{props.canGoPrevious ? <div className='progress-bar-button' onClick={props.onPreviousClick}><b>&lt;</b> Indietro</div> : <div />}
				{props.canGoNext ? <div className='progress-bar-button' onClick={props.onNextClick}>Avanti <b>&gt;</b></div> : <div />}
			</div>
			<div className="progress-bar-container">
				<div className="progress-bar-white" />
				<div className="progress-bar-fuchsia" style={{ width: `${props.percentage}%` }} />
			</div>
		</div>
	)
}

export default ProgressBar
